import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import Organizer from '../components/Organizer/Organizer';

export class OrganizerPage extends Component {
  render() {
    return (
      <Fragment>
        <TopNavigation></TopNavigation>
                <PageTop pageTitle="Organizer Details"></PageTop>
                <Organizer></Organizer>
                <Footer></Footer>
      </Fragment>
    )
  }
}

export default OrganizerPage
